import { render, staticRenderFns } from "./SecretAdminConfigPage.vue?vue&type=template&id=2c8d5fd6&scoped=true"
import script from "./SecretAdminConfigPage.vue?vue&type=script&lang=js"
export * from "./SecretAdminConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d5fd6",
  null
  
)

export default component.exports